import { MarriageProvider } from "./marriage";
import { GraduationProvider } from "./graduation";
import { DrinksProvider } from "../providers/beers";
import { ConfraternizationProvider } from "./confraternization";

export const Providers = ({ children }) => (
  <DrinksProvider>
    <ConfraternizationProvider>
      <MarriageProvider>
        <GraduationProvider>{children}</GraduationProvider>
      </MarriageProvider>
    </ConfraternizationProvider>
  </DrinksProvider>
);
